/** @format */

import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-component-brand-link',
	imports: [CommonModule, HmfTextLinkComponent],
	templateUrl: './brand-link.component.html',
	styleUrl: './brand-link.component.scss'
})
export class BrandLinkComponent {
	readonly brandLink = input.required<{ name: string; url: string }>();
	readonly isMobile = input.required<boolean>();

	readonly size = computed(() => (this.isMobile() ? 'medium' : 'large'));
	readonly dataEm = computed(() => {
		const brandName = this.brandLink().name;
		const brandNameSanitized = brandName.replace(/ /g, '_');
		return `pdpProductTitle_${brandNameSanitized}`;
	});
}
